module.exports = __webpack_public_path__ + "img/queue_img.177b2e5c.png";